// @flow
'use strict';

import * as React from 'react';

import type { IImpostos } from '../types';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

export default function Impostos( { item } : { item : IImpostos }) {
  const { ibsCbs } = item || {};
  const { ibsEstadual, ibsMunicipal, valoresCbs, totalizadores, tribRegular, comprasGovernamentais } = ibsCbs || {};
  return (
      <div className="tab-pane active">
        <h3>Impostos Diversos</h3>
        <h3>IBS e CBS</h3>
        <RowDetalhes data={ ibsCbs }>
          <ColumnDetalhes field="codLocalidadeIncidencia" width="33%">Código Localidade de Incidência</ColumnDetalhes>
          <ColumnDetalhes field="nomeLocalidadeIncidencia" width="33%">Nome Localidade de Incidência</ColumnDetalhes>
          <ColumnDetalhes field="percRedutor" type="percentual" width="33%">Perc Red Alíquota em Compra
            Governamental</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ ibsCbs }>
          <ColumnDetalhes field="valorBaseCalculo" type="moeda" width="33%">Base de Cálculo</ColumnDetalhes>
          <ColumnDetalhes field="valorObjetoRessarcimento" type="moeda" width="33%">Valor objeto de ressarcimento</ColumnDetalhes>
          <ColumnDetalhes field="valorDeducaoReducaoBc" type="moeda" width="33%">Valor dedução/redução BC</ColumnDetalhes>
        </RowDetalhes>

        <h4>IBS Estadual</h4>
        <RowDetalhes data={ ibsEstadual }>
          <ColumnDetalhes field="aliquotaIbsEstadual" type="percentual" width="33%">Alíquota</ColumnDetalhes>
          <ColumnDetalhes field="percRedAliqIbsEstadual" type="percentual" width="33%">Perc Red. Alíquota</ColumnDetalhes>
          <ColumnDetalhes field="aliqEfetivaIbsEstadual" type="percentual" width="33%">Alíquota Efetiva</ColumnDetalhes>
        </RowDetalhes>

        <h4>IBS Municipal</h4>
        <RowDetalhes data={ ibsMunicipal }>
          <ColumnDetalhes field="aliquotaIbsMunicipal" type="percentual" width="33%">Alíquota</ColumnDetalhes>
          <ColumnDetalhes field="percRedAliqIbsMunicipal" type="percentual" width="33%">Perc Red. Alíquota</ColumnDetalhes>
          <ColumnDetalhes field="aliqEfetivaIbsMunicipal" type="percentual" width="33%">Alíquota Efetiva</ColumnDetalhes>
        </RowDetalhes>

        <h4>Valores CBS</h4>
        <RowDetalhes data={ valoresCbs }>
          <ColumnDetalhes field="aliquotaCbs" type="percentual" width="33%">Alíquota União</ColumnDetalhes>
          <ColumnDetalhes field="percRedAliqCbs" type="percentual" width="33%">Perc Red. Alíquota</ColumnDetalhes>
          <ColumnDetalhes field="aliqEfetivaCbs" type="percentual" width="33%">Alíquota Efetiva</ColumnDetalhes>
        </RowDetalhes>

        <h4>Totalizadores</h4>
        <RowDetalhes data={ totalizadores }>
          <ColumnDetalhes field="valorTotalNfe" type="moeda" width="33%">Valor Total NFe considerando os impostos
            por fora: IBS e CBS</ColumnDetalhes>
          <ColumnDetalhes field="totalIbs" type="moeda" width="33%">Total IBS</ColumnDetalhes>
          <ColumnDetalhes field="aliqCredPresIbs" type="percentual" width="33%">Alíquota Crédito Presumido
            IBS</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalizadores }>
          <ColumnDetalhes field="valorCredPresIbs" type="moeda" width="33%">Valor Crédito Presumido
            IBS</ColumnDetalhes>
          <ColumnDetalhes field="diferimentoIbsEstadual" type="moeda" width="33%">Diferimento IBS Estadual</ColumnDetalhes>
          <ColumnDetalhes field="totalIbsEstadual" type="moeda" width="33%">Total IBS Estadual</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalizadores }>
          <ColumnDetalhes field="diferimentoIbsMunicipal" type="moeda" width="33%">Diferimento IBS Municipal</ColumnDetalhes>
          <ColumnDetalhes field="totalIbsMunicipal" type="moeda" width="33%">Total IBS Municipal</ColumnDetalhes>
          <ColumnDetalhes field="aliqCredPresCbs" type="percentual" width="33%">Alíquota Crédito Presumido
            CBS</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ totalizadores }>
          <ColumnDetalhes field="valorCredPresCbs" type="moeda" width="33%">Valor Crédito Presumido
            CBS</ColumnDetalhes>
          <ColumnDetalhes field="diferimentoCbs" type="moeda" width="33%">Diferimento CBS</ColumnDetalhes>
          <ColumnDetalhes field="totalCbsUniao" type="moeda" width="33%">Total CBS União</ColumnDetalhes>
        </RowDetalhes>

        <h4>Tributação Regular</h4>
        <RowDetalhes data={ tribRegular }>
          <ColumnDetalhes field="aliqEfetivaIbsEstadual" type="percentual" width="33%">Alíquota Efetiva IBS
            Estadual</ColumnDetalhes>
          <ColumnDetalhes field="valorIbsEstadual" type="moeda" width="33%">Valor IBS Estadual</ColumnDetalhes>
          <ColumnDetalhes field="aliqEfetivaIbsMunicipal" type="percentual" width="33%">Alíquota Efetiva IBS
            Municipal</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ tribRegular }>
          <ColumnDetalhes field="valorIbsMunicipal" type="moeda" width="33%">Valor IBS Municipal</ColumnDetalhes>
          <ColumnDetalhes field="aliqEfetivaCbs" type="percentual" width="33%">Alíquota Efetiva CBS</ColumnDetalhes>
          <ColumnDetalhes field="valorCbs" type="moeda" width="33%">Valor CBS</ColumnDetalhes>
        </RowDetalhes>

        <h4>IBS e CBS em Compras Governamentais</h4>
        <RowDetalhes data={ comprasGovernamentais }>
          <ColumnDetalhes field="aliquotaIbsUnidFed" type="percentual" width="33%">Alíquota IBS da UF</ColumnDetalhes>
          <ColumnDetalhes field="tributoIbsUnidFed" type="moeda" width="33%">Tributo do IBS da UF</ColumnDetalhes>
          <ColumnDetalhes field="aliqIbsMunicipio" type="percentual" width="33%">Alíquota IBS do município</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ comprasGovernamentais }>
          <ColumnDetalhes field="tributoIbsmunicipio" type="moeda" width="33%">Tributo do IBS do município</ColumnDetalhes>
          <ColumnDetalhes field="aliqCbs" type="percentual" width="33%">Alíquota CBS</ColumnDetalhes>
          <ColumnDetalhes field="valorCbs" type="moeda" width="33%">Valor CBS</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}